import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EEstateType } from '../../../../json_query';
import { getTermsValue } from '../../../../json_query/reducers/helpers';
import { pushTermsValue, removeTermsValue } from '../../../state/advanced/terms';
import { Row } from '../markup';
import { ButtonCheckboxList } from './button_checkbox_list';

const estateTypes = [
  { title: 'В аренде', value: EEstateType.Rent },
  { title: 'В собственности', value: EEstateType.Owned },
];

export interface IEstateTypeComponentProps {
  selected: EEstateType[];
  select(value: EEstateType): void;
  deselect(value: EEstateType): void;
}

class EstateTypeComponent extends React.PureComponent<IEstateTypeComponentProps> {
  public render() {
    const { deselect, selected, select } = this.props;

    return (
      <Row title="Недвижимость в">
        <ButtonCheckboxList deselect={deselect} list={estateTypes} select={select} selected={selected} />
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    selected: getTermsValue('estate_type')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    select: (value: EEstateType) => {
      dispatch(pushTermsValue('estate_type')(value));
    },
    deselect: (value: EEstateType) => {
      dispatch(removeTermsValue('estate_type')(value));
    },
  }),
)(EstateTypeComponent);
